import { IconProps } from 'interfaces';
import COLOR from 'constants/color';

const Calendar = ({
  fill = COLOR.GRAY['900'],
  className = 'w-4 h-4',
  styles
}: IconProps) => {
  return (
    <svg
      className={styles || className}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      preserveAspectRatio='xMidYMid meet'
    >
      <rect
        x='3'
        y='4'
        width='18'
        height='18'
        rx='2'
        ry='2'
        stroke={fill}
        strokeWidth='2'
        fill='none'
      />
      <line
        x1='16'
        y1='2'
        x2='16'
        y2='6'
        stroke={fill}
        strokeWidth='2'
        strokeLinecap='round'
      />
      <line
        x1='8'
        y1='2'
        x2='8'
        y2='6'
        stroke={fill}
        strokeWidth='2'
        strokeLinecap='round'
      />
      <line
        x1='3'
        y1='10'
        x2='21'
        y2='10'
        stroke={fill}
        strokeWidth='2'
        strokeLinecap='round'
      />
      <text
        x='12'
        y='18'
        textAnchor='middle'
        fontSize='7'
        fill={fill}
        fontWeight='bold'
        fontFamily='Arial, sans-serif'
      >
        17
      </text>
    </svg>
  );
};

export default Calendar;
